module.exports = __webpack_public_path__ + "img/Brian_King@3x.c1991c7a.png";